import React, { useEffect, useState } from "react";
import Joyride, { Step } from "react-joyride";

interface TutorialProps {
    startTutorial: boolean;
    setStartTutorial: (value: boolean) => void;
    setDrawerOpen: (open: boolean) => void;
}

const Tutorial: React.FC<TutorialProps> = ({ startTutorial, setStartTutorial, setDrawerOpen }) => {
    const [run, setRun] = useState(false);

    useEffect(() => {
        if (startTutorial) {
            setDrawerOpen(true); // Avaa valikon
            setTimeout(() => setRun(true), 500); // Odota hetki ennen tutorialin aloitusta
        }
    }, [startTutorial, setDrawerOpen]);

    const steps: Step[] = [
        {
            target: "#uusi-tyovuoro",
            content: "Aloita lisäämällä uusi työvuoro",
        },
        {
            target: "#drawer-valikko",
            content: "Tässä on eri sivut, joille voit siirtyä.",
        },
        {
            target: "#tilastot-linkki",
            content: "Tästä näet tilastot.",
        },
        {
            target: "#kirjaa-linkki",
            content: "Tässä voit kirjata uuden työvuoron.",
        },
    ];

    return (
        <Joyride
            steps={steps}
            run={run}
            continuous
            showProgress
            showSkipButton
            callback={(data) => {
                if (data.status === "finished" || data.status === "skipped") {
                    setRun(false);
                    setStartTutorial(false);
                    setDrawerOpen(false); // Sulje valikko tutorialin lopussa
                }
            }}
        />
    );
};

export default Tutorial;
